<template>
    <div class="f-warranty-claim-wrap">
        <form autocomplete="off" @submit.prevent="submitWarrantyClaim">
            <div class="f-pb-3">
                <div style="border: 1.5px solid #000000;">
                    <table class="f-fullwidth">
                        <tr>
                            <td class="f-text-center">
                                <h4 class="f-title f-pt-3 f-pb-3">Warranty Claim Form</h4>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="f-text-center f-pt-1 f-pb-1 f-pl-3 f-pr-3">
                                    <p>To file a warranty claim the <i>Warranty Claim Form</i> shall be filled out and returned to the Field Service Manager via email. This form will be returned to the customer with a claim number in the top right-hand corner.</p>
                                    <p>Regardless the nature of the claim the corresponding elevator traction machine type and serial number <u>must</u> be provided for tracking purposes</p>
                                </div>
                            </td>
                        </tr>
                    </table>

                    <table class="f-fullwidth">
                        <tr>
                            <td colspan="4" class="f-text-center f-no-top-border">
                                <h4 class="f-title f-pt-1 f-pb-1">Job Information</h4>
                            </td>
                        </tr>
                        <tr>
                            <td class="f-td-fit-content f-text-right f-pl-5 f-pr-2">
                                <strong>a. Company Name</strong>
                            </td>
                            <td>
                                <input type="text" v-model="jsondata.jobInformation.companyName" class="f-fullwidth" required>
                            </td>
                            <td  class="f-td-fit-content f-pl-2 f-pr-2">
                                <strong>a. Location</strong>
                            </td>
                            <td>
                                <input type="text" v-model="jsondata.jobInformation.companyLocation" class="f-fullwidth" required>
                            </td>
                        </tr>
                        <tr>
                            <td class="f-td-fit-content f-text-right f-pl-5 f-pr-2">
                                <strong>a. Jobsite Name</strong>
                            </td>
                            <td>
                                <input type="text" v-model="jsondata.jobInformation.jobsiteName" class="f-fullwidth" required>
                            </td>
                            <td  class="f-td-fit-content f-pl-2 f-pr-2">
                                <strong>a. Location</strong>
                            </td>
                            <td>
                                <input type="text" v-model="jsondata.jobInformation.jobsiteLocation" class="f-fullwidth" required>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="4">
                                <div class="f-bg-empty"></div>
                            </td>
                        </tr>
                    </table>

                    <table class="f-fullwidth">
                        <tr>
                            <td colspan="6" class="f-text-center f-no-top-border">
                                <h4 class="f-title f-pt-1 f-pb-1">
                                    Machine Nameplate*
                                    <button type="button" :disabled="!canAdd" class="btn btn-success f-btn-ui" @click.prevent="appendMachineNameplate">+ Add Car</button>
                                    <button type="button" :disabled="!canRemove" class="btn btn-danger f-btn-ui" @click.prevent="removeMachineNameplate">- Remove Car</button>
                                </h4>
                            </td>
                        </tr>
                        <tr v-for="(machine, machineTypeIndex) in jsondata.machineNameplate" :key="machineTypeIndex">
                            <td class="f-td-fit-content f-text-center f-pl-5 f-pr-5">
                                <strong>@{{alphabetical[machineTypeIndex]}}. Machine Type</strong>
                            </td>
                            <td>
                                <template v-if="jsondata.surveyId > 0">
                                    <input type="hidden" v-model="machine.machineType">
                                    <select class="f-fullwidth" v-model="machine.machineTypeID" @change="onMChange" v-bind:data-mi="machineTypeIndex" required>
                                        <option v-for="(machineType, mi) in jsondata.machineTypes" v-bind:value="machineType.car_num" :key="mi">@{{machineType.machine}}</option>
                                    </select>
                                </template>
                                <template v-else>
                                    <input type="text" v-model="machine.machineType" class="f-fullwidth" required>
                                </template>
                            </td>
                            <td  class="f-td-fit-content f-pl-2 f-pr-2">
                                <strong>@{{alphabetical[machineTypeIndex]}}. Serial No.</strong>
                            </td>
                            <td>
                                <input type="text" v-model="machine.serialNo" class="f-fullwidth" required>
                            </td>
                            <td  class="f-td-fit-content f-pl-2 f-pr-2">
                                <strong>@{{alphabetical[machineTypeIndex]}}. Car #</strong>
                            </td>
                            <td>
                                <input type="text" v-model="machine.carNo" class="f-fullwidth" required>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="6">
                                <div class="f-text-center f-pt-3 f-pb-3">
                                    <span>*For GEARED machines please retrieve data from GEARBOX TOP NAMEPLATE</span>
                                </div>
                            </td>
                        </tr>
                    </table>

                    <table class="f-fullwidth hidden">
                        <tr>
                            <td colspan="4" class="f-no-top-border f-text-center">
                                <h4 class="f-title f-pt-1 f-pb-1">Encoder Data (if applicable)</h4>
                            </td>
                        </tr>
                        <tr>
                            <td class="f-td-fit-content f-pl-2 f-pr-2">
                                <strong>Encoder I.D Number</strong>
                            </td>
                            <td>
                                <input type="text" v-model="jsondata.encoderData.encoderId" class="f-fullwidth">
                            </td>
                            <td  class="f-td-fit-content f-pl-2 f-pr-2">
                                <strong>Serial No.</strong>
                            </td>
                            <td>
                                <input type="text" v-model="jsondata.encoderData.serialNo" class="f-fullwidth">
                            </td>
                        </tr>
                        <tr>
                            <td colspan="4">
                                <div class="f-bg-empty"></div>
                            </td>
                        </tr>
                    </table>

                    <table class="f-fullwidth">
                        <tr>
                            <td class="f-no-top-border f-text-center">
                                <h4 class="f-title f-pt-1 f-pb-1">Detailed Reason For Warranty Claim</h4>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <textarea v-model="jsondata.reason" class="f-fullwidth" rows="5" style="resize: none; margin-bottom: -4px" required></textarea>
                            </td>
                        </tr>
                    </table>

                    <table class="f-fullwidth">
                        <tr>
                            <td class="f-no-top-border f-text-center" colspan="4">
                                <h4 class="f-title f-pt-1 f-pb-1">Contact Information</h4>
                            </td>
                        </tr>
                        <tr>
                            <td class="f-td-fit-content f-pl-5 f-pr-2 f-text-right">
                                <strong>a. Submitter Name</strong>
                            </td>
                            <td>
                                <input type="text" v-model="jsondata.contactInformation.submitterName" class="f-fullwidth" required>
                            </td>
                            <td class="f-td-fit-content f-pl-2 f-pr-2">
                                <strong>a. Job Title</strong>
                            </td>
                            <td>
                                <input type="text" v-model="jsondata.contactInformation.jobTitle" class="f-fullwidth" required>
                            </td>
                        </tr>
                        <tr>
                            <td class="f-td-fit-content f-pl-5 f-pr-2 f-text-right">
                                <strong>a. Email</strong>
                            </td>
                            <td>
                                <input type="email" v-model="jsondata.contactInformation.email" class="f-fullwidth" required>
                            </td>
                            <td class="f-td-fit-content f-pl-2 f-pr-2">
                                <strong>a. Phone #</strong>
                            </td>
                            <td>
                                <input type="text" v-model="jsondata.contactInformation.phoneNo" class="f-fullwidth" required>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="4">
                                <div class="f-bg-empty" style="height: 50px;"></div>
                            </td>
                        </tr>
                    </table>

                    <table class="f-fullwidth">
                        <tr>
                            <td class="f-no-top-border f-text-center" colspan="4">
                                <h4 class="f-title f-pt-1 f-pb-1">Shipping Address</h4>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="4">
                                <div class="f-text-center f-pt-3 f-pb-3">
                                    <span>Please provide shipping address in the case that a replacment item will need to be sent</span>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="f-text-center" colspan="2">
                                <strong>Company Name</strong>
                            </td>
                            <td class="f-text-center" colspan="2">
                                <strong>Street Address</strong>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <input type="text" class="f-fullwidth f-text-center" v-model="jsondata.shippingAddress.companyName" required>
                            </td>
                            <td colspan="2">
                                <input type="text" class="f-fullwidth f-text-center" v-model="jsondata.shippingAddress.streetAddress" required>
                            </td>
                        </tr>
                        <tr>
                            <td class="f-text-center">
                                <strong>City/Province</strong>
                            </td>
                            <td class="f-text-center">
                                <strong>State</strong>
                            </td>
                            <td class="f-text-center">
                                <strong>Zipcode</strong>
                            </td>
                            <td class="f-text-center">
                                <strong>Country</strong>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <input type="text" class="f-fullwidth f-text-center" v-model="jsondata.shippingAddress.city" required>
                            </td>
                            <td>
                                <input type="text" class="f-fullwidth f-text-center" v-model="jsondata.shippingAddress.state" required>
                            </td>
                            <td>
                                <input type="text" class="f-fullwidth f-text-center" v-model="jsondata.shippingAddress.zipcode" required>
                            </td>
                            <td>
                                <input type="text" class="f-fullwidth f-text-center" v-model="jsondata.shippingAddress.country" required>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="4">
                                <div class="f-bg-empty" style="height: 50px;"></div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

            <div class="f-pt-2 f-text-right">
                <button type="submit" :disabled="isSubmitting" class="btn btn-primary">
                    <template v-if="isSubmitting"><span class="fa fa-spinner fa-pulse"></span></template>
                    <template v-else>Submit Warranty Claim</template>
                </button>
            </div>
        </form>                
    </div>
</template>
<script>
export default {
    data() {
        return {
            isSubmitting: false,
            jsondata: {
                jobInformation: {
                    companyName: '',
                    companyLocation: '',
                    jobsiteName: '',
                    jobsiteLocation: ''
                },
                machineNameplate: [
                    {
                        machineTypeID: '',
                        machineType: '',
                        serialNo: '',
                        carNo: ''
                    }
                ],
                encoderData: {
                    encoderId: '',
                    serialNo: ''
                },
                reason: '',
                contactInformation: {
                    submitterName: '',
                    email: '',
                    jobTitle: '',
                    phoneNo: ''
                },
                shippingAddress: {
                    companyName: '',
                    streetAddress: '',
                    city: '',
                    state: '',
                    zipcode: '',
                    country: ''
                },
                machineTypes: [],
                surveyId: 0
            }
        }
    },
    mounted() {
        this.get_survey()
    },
    computed: {
        alphabetical() {
            return 'abcdefghijklmnopqrstuvwxyz'.split('')
        },
        canAdd() {
            return this.jsondata.machineNameplate.length < this.alphabetical.length ? true : false
        },
        canRemove() {
            return this.jsondata.machineNameplate.length > 1 ? true : false
        },
        postPayload() {
            return {
                ...this.jsondata, 
                jobInformation: JSON.stringify(this.jsondata.jobInformation),
                machineNameplate: JSON.stringify(this.jsondata.machineNameplate),
                encoderData: JSON.stringify(this.jsondata.encoderData),
                contactInformation: JSON.stringify(this.jsondata.contactInformation),
                shippingAddress: JSON.stringify(this.jsondata.shippingAddress),
                surveyId: this.jsondata.surveyId
            }
        }
    },
    methods: {
        get_survey() {
            if(this.$route.params.surveyId && this.$route.params.surveyId > 0) {
                this.jsondata.surveyId = this.$route.params.surveyId
                this.onWChange()
            }
        },
        onMChange(event) {
            let mi = event.srcElement.value
            let i = event.srcElement.dataset.mi
            
            this.jsondata.machineNameplate[i].machineTypeID = mi
            this.jsondata.machineNameplate[i].machineType = this.jsondata.machineTypes[mi].machine
            this.jsondata.machineNameplate[i].carNo = this.jsondata.machineTypes[mi].car_id
        },
        onWChange() {
            this.$http.get('/api/warranty-claim/' + this.jsondata.surveyId)
                .then(response => {
                    let data = response.data
                    let hasMatch = false

                    this.jsondata.jobInformation.companyName = data.company_name
                    this.jsondata.jobInformation.jobsiteName = data.project_name
                    this.jsondata.machineTypes = ( this.jsondata.surveyId == 0 ) ? [{'machine':''}] : data.machines

                    this.jsondata.machineNameplate = []
                    for(let cn in data.machines) {
                        this.jsondata.machineNameplate.push({
                            machineTypeID: data.machines[cn].car_num,
                            machineType: data.machines[cn].machine,
                            serialNo: '',
                            carNo: data.machines[cn].car_id
                        })
                        hasMatch = true
                    }
                    if(!hasMatch) {
                        this.jsondata.machineNameplate = [
                            {
                                machineTypeID: '',
                                machineType: '',
                                serialNo: '',
                                carNo: ''
                            }
                        ]
                    }
                })
        },
        removeMachineNameplate() {
            this.jsondata.machineNameplate.splice(this.jsondata.machineNameplate.length-1, 1)
        },
        appendMachineNameplate() {
            this.jsondata.machineNameplate.push({
                machineType: '',
                serialNo: '',
                carNo: ''
            })
        },
        submitWarrantyClaim() {
            this.isSubmitting = true
            this.$http.post('/api/warranty-claim', this.postPayload)
                .then(response => {
                    let data = response.data
                    this.isSubmitting = false
                    this.reset_form()
                    alert(data.message)
                })
                .catch(() => {
                    this.isSubmitting = false
                    alert('Something went wrong!')
                })
        },
        reset_form() {
            this.jsondata =  {
                jobInformation: {
                    companyName: '',
                    companyLocation: '',
                    jobsiteName: '',
                    jobsiteLocation: ''
                },
                machineNameplate: [
                    {
                        machineTypeID: '',
                        machineType: '',
                        serialNo: '',
                        carNo: ''
                    }
                ],
                encoderData: {
                    encoderId: '',
                    serialNo: ''
                },
                reason: '',
                contactInformation: {
                    submitterName: '',
                    email: '',
                    jobTitle: '',
                    phoneNo: ''
                },
                shippingAddress: {
                    companyName: '',
                    streetAddress: '',
                    city: '',
                    state: '',
                    zipcode: '',
                    country: ''
                },
                machineTypes: [],
                surveyId: 0
            }
            this.get_survey()
        }
    }
}
</script>
<style scoped>
.f-warranty-claim-wrap .f-w-c-heading {
	background: rgb(150,150,150)!important;
	background: linear-gradient(90deg, rgba(150,150,150,1) 27%, rgba(255,255,255,1) 80%)!important;
	-webkit-print-color-adjust: exact!important;
}
.f-warranty-claim-wrap .f-w-c-heading img {
	margin-top: -15px;
	margin-bottom: -15px;
}
.f-warranty-claim-wrap hr {
	border-color: #000000;
	margin-top: 5px;
    margin-bottom: 5px;
}
.f-warranty-claim-wrap table {
	border-collapse: collapse;
}
.f-warranty-claim-wrap table > tbody > tr:first-child td {
	font-size: unset!important;
}
.f-warranty-claim-wrap table tr td {
	border: 2px solid #000000;
	margin: 0;
	padding: 0;
}
.f-warranty-claim-wrap table tr td select{
	height: 22px;
	min-width: 190px;
}
.f-warranty-claim-wrap table tr td input,
.f-warranty-claim-wrap table tr td select,
.f-warranty-claim-wrap table tr td textarea {
	background: #d6d6f3;
	border-color: transparent;
	font-weight: bold;
}
.f-warranty-claim-wrap table tr td input:focus,
.f-warranty-claim-wrap table tr td select:focus,
.f-warranty-claim-wrap table tr td textarea:focus {
	background: #ffffff;
	outline: none;
}
.f-warranty-claim-wrap footer {
	background: none;
    border: 0;
    padding: 0;
    margin: 0;
}
.f-warranty-claim-wrap footer table {
	max-width: 100% !important;
}
.f-warranty-claim-wrap footer table tr td {
	border: none;
	color: #333;
	font-size: 11px;
	line-height: 13px;
	white-space: nowrap;
}
.f-warranty-claim-wrap .f-text-right {
	text-align: right!important;
}
.f-warranty-claim-wrap .f-text-center {
	text-align: center!important;
}
.f-warranty-claim-wrap .f-fullwidth {
	width: 100%;
}
.f-warranty-claim-wrap .f-title {
	margin-top: 0;
	margin-bottom: 0;
	background: #E7E6E6;
	font-size: 16px;
	font-weight: bold;
}
.f-warranty-claim-wrap .f-bg-input-empty {
	background: #d6d6f3;
	height: 25px;
}

.f-warranty-claim-wrap .f-bg-empty {
	height: 25px;
}

.f-warranty-claim-wrap .f-no-top-border {
	border-top: 0;
}

.f-warranty-claim-wrap .f-no-bottom-border {
	border-bottom: 0;
}
.f-warranty-claim-wrap .f-td-fit-content {
	width:1%;
    white-space:nowrap;
}
.f-warranty-claim-wrap strong,
.f-warranty-claim-wrap span,
.f-warranty-claim-wrap p {
	font-size: 14px;
}
.f-warranty-claim-wrap ul {
	list-style: none;
	margin: 0;
	padding: 0;
}

.f-warranty-claim-wrap ul li {
	font-size: 13px;
	font-weight: bold;
}

.f-warranty-claim-wrap ul li a {
	text-decoration: none;
	color: #000000;
}

.f-warranty-claim-wrap .f-d-flex {
	display: -webkit-box;
	display: -webkit-flex;
	-webkit-flex-wrap: wrap;
	display: flex;
	flex-wrap: wrap;
}

.f-warranty-claim-wrap .f-justify-content-between {
	justify-content: space-between;
	-webkit-justify-content: space-between;
}

.f-warranty-claim-wrap .f-justify-content-end {
	justify-content: flex-end;
	-webkit-justify-content: flex-end;
}

/**/

.f-warranty-claim-wrap .f-pt-1 {
	padding-top:.25rem!important;
}

.f-warranty-claim-wrap .f-pl-1 {
	padding-left:.25rem!important;
}

.f-warranty-claim-wrap .f-pr-1 {
	padding-right:.25rem!important;
}

.f-warranty-claim-wrap .f-pb-1 {
	padding-bottom:.25rem!important;
}

/**/

.f-warranty-claim-wrap .f-pt-2 {
	padding-top:.5rem!important;
}

.f-warranty-claim-wrap .f-pl-2 {
	padding-left:.5rem!important;
}

.f-warranty-claim-wrap .f-pr-2 {
	padding-right:.5rem!important;
}

.f-warranty-claim-wrap .f-pb-2 {
	padding-bottom:.5rem!important;
}

/**/

.f-warranty-claim-wrap .f-pt-3 {
	padding-top:1rem!important;
}

.f-warranty-claim-wrap .f-pl-3 {
	padding-left:1rem!important;
}

.f-warranty-claim-wrap .f-pr-3 {
	padding-right:1rem!important;
}

.f-warranty-claim-wrap .f-pb-3 {
	padding-bottom:1rem!important;
}

/**/

.f-warranty-claim-wrap .f-pt-4 {
	padding-top:1.5rem!important;
}

.f-warranty-claim-wrap .f-pl-4 {
	padding-left:1.5rem!important;
}

.f-warranty-claim-wrap .f-pr-4 {
	padding-right:1.5rem!important;
}

.f-warranty-claim-wrap .f-pb-4 {
	padding-bottom:1.5rem!important;
}

/**/

.f-warranty-claim-wrap .f-pt-5 {
	padding-top:3rem!important;
}

.f-warranty-claim-wrap .f-pl-5 {
	padding-left:3rem!important;
}

.f-warranty-claim-wrap .f-pr-5 {
	padding-right:3rem!important;
}

.f-warranty-claim-wrap .f-pb-5 {
	padding-bottom:3rem!important;
}

/**/

.f-warranty-claim-wrap .f-mb-5 {
	margin-bottom:3rem!important;
}

.f-warranty-claim-wrap .f-btn-ui {
	padding: 0 5px!important;
	font-size: 10px;
}

.f-warranty-claim-wrap .f-btn-ui:focus {
	outline: none;
}

.f-warranty-claim-wrap table.f-no-border tr td {
	border-width: 0!important;
	border-color: transparent!important;
}

.f-warranty-claim-wrap table tr td.f-no-border span {
	font-size: 12px!important;
}

.hidden {
    display: none;
}
</style>